import * as types from '../mutation-types'
import utils from '../../services/utils'
import API from '../../services/api'

const state = {
  config: {
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd'
    }
  },
  saleType: types.NONE,
  currentItemsOrders: null,
  currentMap: null,
  isLoading: true,
  currentDueDate: utils.formatDateUTC(new Date())
}

const mutations = {
  [types.CLOSE_MENU] (state) {
    if (document.documentElement.clientWidth < 992) {
      state.sidebar.opened = false
    }
  },
  [types.TOGGLE_SIDEBAR] (state, opened) {
    state.sidebar.opened = opened
  },
  [types.TOGGLE_WITHOUT_ANIMATION] (state, value) {
    state.sidebar.withoutAnimation = value
  },
  [types.SET_CURRENT_ITEMS] (state, value) {
    state.currentItemsOrders = value
  },
  [types.SET_CURRENT_MAP] (state, value) {
    state.currentMap = value
  },
  setSaleType (state, value) {
    state.saleType = value
  },
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setDueDate (state, value) {
    state.currentDueDate = value
  }
}

const actions = {
  closeMenu ({ commit }) {
    commit(types.CLOSE_MENU)
  },
  toggleSidebar ({ commit }, opened) {
    commit(types.TOGGLE_SIDEBAR, opened)
  },
  isToggleWithoutAnimation ({ commit }, value) {
    commit(types.TOGGLE_WITHOUT_ANIMATION, value)
  },
  setCurrentItems ({ commit }, value) {
    if (value == null) {
      commit(types.SET_CURRENT_ITEMS, null)
      return
    }
    API.getItems(value.store_id, value.order_id)
      .then(data => {
        commit(types.SET_CURRENT_ITEMS, {data: data, address: value.address})
      })
  },
  setCurrentMap ({ commit }, value) {
    commit(types.SET_CURRENT_MAP, value)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js